import basic from  './basic'
import service from  './service'
// import module from  './module'

const en = {
    ...basic,
    ...service,
    // ...module,
}

export default en
